import {useState} from "react";
import {mrbgStore} from "./mrbg/mrbgRedux";

function OurTeam({mainStyle}){

  const [mrbgVars] = useState(mrbgStore.getState().mrbgVars);

  return(
    <section id={mainStyle.ourTemSec} className={mainStyle.prl_Y}>
      { mrbgVars.pageInfo.ourTeamTitle? <h4 id={mainStyle.ourTemTitle}>{mrbgVars.pageInfo.ourTeamTitle}</h4>: '' }
      <div id={mainStyle.ourTemRow} className={mainStyle.flexRow}>
        {
          Object.keys(mrbgVars.ourTeam).map(k=>{
            return(
              <a href={`/otm/${mrbgVars.ourTeam[k].id}/${mrbgVars.ourTeam[k].name.replaceAll(' ','_')}`} className={mainStyle.ourTemItem} target="_blank" key={k}>
                <figure>
                  <img src={`/img/${mrbgVars.ourTeam[k].img}`} alt={mrbgVars.ourTeam[k].alt}/>
                </figure>
                <div className={mainStyle.ourTemTxt}>
                  <h3>{mrbgVars.ourTeam[k].name}</h3>
                  <div>{mrbgVars.ourTeam[k].position}</div>
                </div>
              </a>
            )
          })
        }
      </div>
    </section>
  )
}
export default OurTeam;